/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiEntitySchemaFieldType {
    TEXT = 'TEXT',
    KEYWORD = 'KEYWORD',
    NUMBER = 'NUMBER',
    DATETIME = 'DATETIME',
    OBJECT = 'OBJECT',
    ENUM = 'ENUM'
}


export function instanceOfInternalApiEntitySchemaFieldType(value: any): boolean {
    for (const key in InternalApiEntitySchemaFieldType) {
        if (Object.prototype.hasOwnProperty.call(InternalApiEntitySchemaFieldType, key)) {
            if (InternalApiEntitySchemaFieldType[key as keyof typeof InternalApiEntitySchemaFieldType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiEntitySchemaFieldTypeFromJSON(json: any): InternalApiEntitySchemaFieldType {
    return InternalApiEntitySchemaFieldTypeFromJSONTyped(json, false);
}

export function InternalApiEntitySchemaFieldTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiEntitySchemaFieldType {
    return json as InternalApiEntitySchemaFieldType;
}

export function InternalApiEntitySchemaFieldTypeToJSON(value?: InternalApiEntitySchemaFieldType | null): any {
    return value as any;
}

export function InternalApiEntitySchemaFieldTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiEntitySchemaFieldType {
    return value as InternalApiEntitySchemaFieldType;
}

